import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PhBhpUiService {

  constructor() { }
}

export const sanitize = (value: any) => {
  if (typeof value === 'number') value = value.toString();
  var regex = /(<([^>]+)>)/ig
  return value.replace(regex, "").replace(/&([\s]*)gt;/ig, '').replace(/&([\s]*)lt;/ig, '').replace(/&([\s]*)amp;/ig, '').replace(/\{[\s]*\{/, '').replace(/\}[\s]*\}/, '');
};
